import { useTranslation } from 'react-i18next';

const icons = [
  'ri-rocket-line',
  'ri-user-2-line',
  'ri-store-2-line',
  'ri-briefcase-4-line',
];

const accentColors = [
  'bg-[#F0E8F8] border-[#D4B8F0] text-[#4F2D63]',
  'bg-[#FFF5E8] border-[#FFDBA8] text-[#9B5A00]',
  'bg-[#E8F8F0] border-[#A8F0C8] text-[#006B3F]',
  'bg-[#FFF0F0] border-[#FFBDBD] text-[#9B0000]',
];

export default function WhoForSection() {
  const { t } = useTranslation();

  const cards = [1, 2, 3, 4].map((n, i) => ({
    icon: icons[i],
    accent: accentColors[i],
    title: t(`sllc_who_${n}_title`),
    desc: t(`sllc_who_${n}_desc`),
  }));

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-[#4F2D63] text-sm font-semibold uppercase tracking-widest">
            {t('sllc_who_eyebrow')}
          </span>
          <h2 className="mt-3 text-3xl lg:text-4xl font-bold text-gray-900">
            {t('sllc_who_title')}
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card) => (
            <div key={card.title} className="rounded-lg border border-[#E9D9F2] p-6 flex flex-col gap-4 bg-white">
              <div className={`w-12 h-12 flex items-center justify-center rounded-lg border ${card.accent}`}>
                <i className={`${card.icon} text-xl`} />
              </div>
              <h3 className="font-bold text-gray-900 text-sm leading-snug">{card.title}</h3>
              <p className="text-xs text-gray-600 leading-relaxed">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
